import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import ReactPerfectScrollbar from 'react-perfect-scrollbar';
import { List } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { SidebarItemsType } from '../../types/sidebar';
import SidebarNavSection from './SidebarNavSection';

import '../../vendor/perfect-scrollbar.css';

const baseScrollbar = (props: any) => css`
  background-color: ${import.meta.env.REACT_APP_BUILD === 'staging'
    ? '#0A342F'
    : '#0b313f'};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex-grow: 1;
`;

const Scrollbar = styled.div`
  ${baseScrollbar}
`;

const PerfectScrollbar = styled(ReactPerfectScrollbar)`
  ${baseScrollbar}
`;

type SidebarNavProps = {
  pages: SidebarItemsType[];
};

const SidebarNav: React.FC<SidebarNavProps> = ({ pages }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const ScrollbarComponent = (
    matches ? PerfectScrollbar : Scrollbar
  ) as React.ElementType;
  return (
    <ScrollbarComponent>
      <nav aria-label="Main navigation" role="navigation">
        <List
          disablePadding
          component="ul"
          sx={{
            paddingTop: (theme) => theme.spacing(10),
            paddingBottom: (theme) => theme.spacing(2.5),
            '& .MuiListItem-root': {
              mb: 1,
            },
          }}
        >
          {pages &&
            pages.map((page, index) => (
              <SidebarNavSection
                key={'title' in page ? page.title : `section-${index}`}
                pages={page.children ?? []}
                title={'title' in page ? page.title : undefined}
              />
            ))}
        </List>
      </nav>
    </ScrollbarComponent>
  );
};

export default SidebarNav;
